/**
 * @flow
 * Created by neo on 20.01.17.
 */
import { observable, computed } from 'mobx';

export default class Person {
    @observable id: string;
    @observable firstname: string;
    @observable middlename: string;
    @observable lastname: string;
    @observable birthdate: any;
    @observable sex: string;

    constructor(json: any) {
        if (json && json.personalDetails) {
            this.id = json.id;
            this.firstname = json.personalDetails.firstname;
            this.middlename = json.personalDetails.middlename;
            this.lastname = json.personalDetails.lastname;
            this.birthdate = json.personalDetails.birthdate;
            this.sex = json.personalDetails.sex;
        }
    }

    @computed get initials(): string {
        let initials = '';
        if (this.firstname) {
            initials += this.firstname.charAt(0);
        }
        if (this.middlename) {
            initials += this.middlename.charAt(0);
        }
        if (this.lastname) {
            initials += this.lastname.charAt(0);
        }
        return initials.toUpperCase();
    }

    @computed get fullName(): string {
        let name = '';
        if (this.firstname) {
            name += this.firstname + ' ';
        }
        if (this.middlename) {
            name += this.middlename + ' ';
        }
        if (this.lastname) {
            name += this.lastname + ' ';
        }
        name = name.trim();
        return name;
    }
}



// WEBPACK FOOTER //
// ./src/App/Store/Person.js